import GenericService from './GenericService';

class KillTransferService extends GenericService {
    constructor() {
        super();
    }

    getCharacters = () =>
        new Promise((resolve, reject) => {
            this.tokenUpdate();
            this.get('shaiya/kill-transfer/characters')
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });

    transferKills = (data) =>
        new Promise((resolve, reject) => {
            this.tokenUpdate();
            this.post('shaiya/kill-transfer', data)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
}

const killTransferService = new KillTransferService();
export default killTransferService;
